import { getBondaLoginUrl, openBondaLogin } from '../../utils';

const BondaLogin = () => {
  const loginUrl = getBondaLoginUrl();

  if (!loginUrl) {
    return (
      <section className="mx-auto max-w-3xl rounded-lg border border-amber-200 bg-amber-50 px-5 py-4 text-amber-900">
        <h1 className="text-lg font-semibold">Bonda no esta configurado</h1>
        <p className="mt-2 text-sm">
          Configure la variable REACT_APP_BONDA_LOGIN_URL con la URL de inicio de sesion de Bonda.
        </p>
      </section>
    );
  }

  return (
    <section className="mx-auto max-w-3xl rounded-lg border border-blue-200 bg-blue-50 px-5 py-4 text-blue-950">
      <h1 className="text-lg font-semibold">Acceso a Bonda</h1>
      <p className="mt-2 text-sm">
        Bonda bloquea la carga dentro del portal con X-Frame-Options sameorigin. Para embeberlo,
        Bonda debe habilitar el dominio del portal o entregar una URL compatible con iframe.
      </p>
      <button
        type="button"
        onClick={openBondaLogin}
        className="mt-4 inline-flex items-center rounded-md bg-personalized px-4 py-2 text-sm font-semibold text-white transition hover:bg-personalized/90"
      >
        Abrir Bonda
      </button>
    </section>
  );
};

export default BondaLogin;
